 import React from "react";
import { Button, Typography, Box, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import styles from "./ContextException.module.css";

import instructImg from "../../asset/robot1.png";
import audioImg from "../../asset/voicebot1.png";
import videoImg from "../../asset/voicebot1.png";

const ContextException = () => {
  const navigate = useNavigate();

  const demos = [
    {
      title: "Mebot For Instruct",
      image: instructImg,
      alt: "Mebot for Instruct Demo",
      path: "/create-bot",
      color: "#00d4ff",
    },
    {
      title: "Mebot For Audio",
      image: audioImg,
      alt: "Mebot for Audio Demo",
      path: "/create-bot",
      color: "#9333ea",
    },
    {
      title: "Mebot For Video",
      image: videoImg,
      alt: "Mebot for Video Demo",
      path: "/create-bot",
      color: "#00ff88",
    },
  ];

  return (
    <section id="contextexception" className={styles.section}>
      {/* Tech background elements */}
      <div className={styles.techBg}>
        <div className={styles.binaryGrid}></div>
        <div className={styles.glowOrb}></div>
        <div className={styles.circuitLines}></div>
      </div>

      <Box className={styles.container}>
        {/* Header */}
        <div className={styles.header}>
          <Typography className={styles.title}>
            Context Exception MeBot
          </Typography>

          <div className={styles.subtitleContainer}>
            <Typography className={styles.subtitle}>
              Advanced AI-powered solutions for specialized industry
              applications. From healthcare scheduling to industrial
              maintenance, our Mebots adapt intelligently to unique context
              requirements.
            </Typography>

            <div className={styles.statusIndicator}>
              <span className={styles.statusDot}></span>
              <span className={styles.statusText}>AI Systems Active</span>
            </div>
          </div>
        </div>

        {/* Demo Cards */}
        <Grid
          container
          spacing={4}
          justifyContent="center"
          className={styles.gridContainer}
        >
          {demos.map((demo) => (
            <Grid item xs={12} sm={6} md={4} key={demo.title}>
              <Box
                className={`${styles.demoCard} ${styles.noHover}`}
                style={{ "--card-color": demo.color }}
              >
                {/* Card glow effects */}
                <div className={styles.cardGlow}></div>
                <div className={styles.cardBorder}></div>

                {/* Icon indicator */}
                <div className={styles.demoIcon}>{demo.icon}</div>

                {/* Image */}
                <div className={styles.imageContainer}>
                  <div className={styles.imageGlow}></div>
                  <img
                    src={demo.image}
                    alt={demo.alt}
                    className={styles.demoImage}
                    loading="lazy"
                  />
                </div>

                {/* Title */}
                <Typography className={styles.demoTitle}>
                  {demo.title}
                </Typography>

                {/* Description */}
                <Typography className={styles.demoDescription}>
                  {demo.title.includes("Instruct") &&
                    "Intelligent instruction processing with real-time adaptation"}
                  {demo.title.includes("Audio") &&
                    "Advanced audio analysis and processing capabilities"}
                  {demo.title.includes("Video") &&
                    "Real-time video processing and pattern recognition"}
                </Typography>

                {/* Button */}
                <Button
                  variant="contained"
                  className={styles.demoButton}
                  onClick={() => {
                    navigate(demo.path);
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  startIcon={<span className={styles.buttonIcon}></span>}
                >
                  Launch Demo
                </Button>
              </Box>
            </Grid>
          ))}
        </Grid>

        {/* Data flow animation */}
        <div className={styles.dataFlow}></div>
      </Box>
    </section>
  );
};

export default ContextException;
